import { AssessmentCompletionSummary } from "@coaching-culture/types";
import {
  Button,
  EmptyState,
  Flex,
  formatDate,
  Img,
  Loader,
  Panel,
  Text,
} from "@coaching-culture/ui";
import axios from "axios";
import { PageHeader } from "components/PageHeader";
import { sortBy } from "lodash";
import { useEffect, useState } from "react";
import { FaClipboardCheck } from "react-icons/fa";

function Completion({
  completion,
}: {
  completion: AssessmentCompletionSummary;
}) {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      p={3}
      borderBottom={1}
      borderColor="border"
    >
      <Flex alignItems="center">
        <Img
          mr={2}
          width="50px"
          src={
            process.env.REACT_APP_STATIC_ROOT + "/" + completion.assessment.icon
          }
        />
        <Flex flexDirection="column">
          <Text fontWeight={600}>{completion.assessment.name}</Text>
          <Text fontSize="small" color="textMuted">
            Completed {formatDate(completion.completedOn)}
          </Text>
        </Flex>
      </Flex>
      <Button
        to={`/solutions/assessments/modules/${completion.assessment.slug}/results/${completion.id}`}
      >
        See results
      </Button>
    </Flex>
  );
}

export function PreviousResults() {
  const [items, setItems] = useState<AssessmentCompletionSummary[] | null>(
    null,
  );

  useEffect(() => {
    axios.get(`/api/users/me/assessment-completions`).then(({ data }) => {
      setItems(data);
    });
  }, []);

  return (
    <>
      <PageHeader
        text="Previous results"
        subtitle="Results from your previous assessments"
      />
      <Panel>
        {items == null ? (
          <Loader />
        ) : items.length === 0 ? (
          <EmptyState
            icon={FaClipboardCheck}
            title="No results yet"
            action={
              <Button to="/solutions/assessments" variant="primary">
                Take an assessment
              </Button>
            }
          >
            Your results will appear here when you complete an assessment.
          </EmptyState>
        ) : (
          sortBy(items, "completedOn")
            .reverse()
            .map((x) => <Completion completion={x} key={x.id} />)
        )}
      </Panel>
    </>
  );
}
